import { useRef } from 'react';
const empty = Symbol('empty');

/** @description Хук для получения ref, который не будет пересоздаваться при каждом рендере */
export function useCallbackRef(getInitValue) {
  const ref = useRef(empty);
  if (ref.current === empty) {
    ref.current = getInitValue();
  }
  return ref;
}